import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-sm btn-bg-primary text-white text-hover-white dropdown-toggle px-4 py-2",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-auto-close": "outside"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard-x-fill p-0 fs-1 text-white" }),
  /*#__PURE__*/_createTextVNode(" Anotaciones ")
], -1)
const _hoisted_2 = { class: "dropdown-menu w-lg-200px w-xl-350px bg-primary" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Observaciones", -1)
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Cambiar de estado", -1)
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "formRec",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right p-6 bg-white"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_form_item, { prop: "message" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.message,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.message) = $event)),
                    type: "textarea",
                    placeholder: "Ingrese aquí las observaciones del rechazo de la participación",
                    rows: 4,
                    maxlength: "100",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_form_item, { prop: "checkdoc" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.checkdoc,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.checkdoc) = $event)),
                    placeholder: "Seleccionar",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-danger w-100",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitForm(_ctx.formRec)))
              }, "Guardar")
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}